var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIlIsrael(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_19477)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.28178 45.12H62.1729V0H-2.28178V45.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.28178 10.152H62.1729V4.22998H-2.28178V10.152ZM-2.28178 41.0398H62.1729V35.1178H-2.28178V41.0398ZM40.2826 16.8054L30.58 33.6902L20.666 16.8847L40.2826 16.8142V16.8054Z",
    fill: "#0038B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4043 28.0061L30.5625 31.1345L28.6766 28.0237L32.4131 28.0061H32.4043Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3174 28.2529L30.606 11.3682L20.7008 28.1824L40.3174 28.2529Z",
    fill: "#0038B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4046 16.8848L30.5628 13.7563L28.6769 16.876L32.4134 16.8848H32.4046ZM36.2644 23.8907L38.1768 27.0632L34.5636 27.0544L36.2644 23.8819V23.8907ZM38.1415 18.0304L34.5108 18.0568L36.2556 21.2558L38.1415 18.0304ZM24.817 23.9348L22.9752 27.0632L26.65 27.0192L24.817 23.9348ZM23.0104 18.0304L26.6412 18.0568L24.8963 21.2558L23.0104 18.0304ZM33.0831 18.0304L35.5859 22.56L33.0479 26.9927L28.3949 27.0985L25.5749 22.56L28.1834 17.9775L33.0831 18.0216V18.0304Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_19477"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlIsrael);
export default __webpack_public_path__ + "static/media/il Israel.466e5639ff4a6280264e332d9cb1842d.svg";
export { ForwardRef as ReactComponent };